import { reducer as formReducer } from 'redux-form'

import { V1_ADD_PRE_FILL_PASSENGERS } from '../actions/passengers/v1addPreFillPassengers'
import { V1_HANDLE_SUCCESSFULLY_UPDATED_PASSENGERS } from '../actions/passengers/v1handleSuccessfullyUpdatedPassengers'

export default formReducer.plugin({
  flightpassengers: (state = [], action = {}) => {
    switch (action.type) {
      case V1_HANDLE_SUCCESSFULLY_UPDATED_PASSENGERS:
        const newValues = { ...state.values }
        action.data.forEach(x => {
          newValues[x.id] = x
          newValues[x.id].dateOfBirth = newValues[x.id].dateOfBirth
        })

        return {
          ...state,
          values: newValues,
          fields: {
            ...state.fields,
          },
        }
      default:
        return state
    }
  },

  newBooking: (state, action = {}) => {
    switch (action.type) {
      case V1_ADD_PRE_FILL_PASSENGERS:
        return action.data

      default:
        return state
    }
  },
})
